import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormikField } from "@air/formik-field";
import { Input } from "@air/primitive-input";
import { getRegistrationValidationSchema } from "@air/utils-auth";
import { Formik } from "formik";
import Form from "~/components/Form";
import PasswordInput from "~/components/Form/PasswordInput";
import { SIGN_UP_EMAIL_INPUT, SIGN_UP_FIRST_NAME_INPUT, SIGN_UP_LAST_NAME_INPUT, SIGN_UP_PASSWORD_INPUT } from "~/constants/testIDs";
import { PASSWORD_REQS_STRING } from "~/utils/Auth";
import { SignUpTermsCheckbox } from "./SignUpTermsCheckbox";
const _SignUpValidationSchema = getRegistrationValidationSchema();
export const EmailSignUpForm = (param)=>{
    let { defaultEmail, formID, onSubmit, disabled, initialValues, termsCheckbox = /*#__PURE__*/ _jsx(SignUpTermsCheckbox, {}), children } = param;
    const validationSchema = getRegistrationValidationSchema(defaultEmail);
    return /*#__PURE__*/ _jsx(Formik, {
        enableReinitialize: true,
        initialValues: {
            ...validationSchema.cast({}),
            ...initialValues
        },
        validationSchema: validationSchema,
        onSubmit: onSubmit,
        validateOnMount: true,
        children: (formikProps)=>/*#__PURE__*/ _jsxs(Form, {
                id: formID,
                children: [
                    /*#__PURE__*/ _jsx(FormikField, {
                        id: "email",
                        className: "mb-4",
                        component: /*#__PURE__*/ _jsx(Input, {
                            type: "email",
                            placeholder: "olivia@companyname.com",
                            autoComplete: "username",
                            size: "large",
                            "data-testid": SIGN_UP_EMAIL_INPUT,
                            disabled: disabled
                        }),
                        label: "Work email *",
                        name: "email"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mb-4 flex gap-2",
                        children: [
                            /*#__PURE__*/ _jsx(FormikField, {
                                id: "firstName",
                                name: "firstName",
                                label: "First name",
                                className: "flex-1",
                                component: /*#__PURE__*/ _jsx(Input, {
                                    type: "text",
                                    autoFocus: true,
                                    autoComplete: "given-name",
                                    size: "large",
                                    "data-testid": SIGN_UP_FIRST_NAME_INPUT,
                                    disabled: disabled
                                })
                            }),
                            /*#__PURE__*/ _jsx(FormikField, {
                                id: "lastName",
                                name: "lastName",
                                label: "Last name",
                                className: "flex-1",
                                component: /*#__PURE__*/ _jsx(Input, {
                                    type: "text",
                                    autoComplete: "family-name",
                                    size: "large",
                                    "data-testid": SIGN_UP_LAST_NAME_INPUT,
                                    disabled: disabled
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(PasswordInput, {
                        description: PASSWORD_REQS_STRING,
                        size: "large",
                        className: "mb-4",
                        testId: SIGN_UP_PASSWORD_INPUT,
                        disabled: disabled
                    }),
                    children === null || children === void 0 ? void 0 : children(formikProps),
                    termsCheckbox
                ]
            })
    });
};
